import React from "react";

//pages
import Groups from "../views/dashboard/app/groups";
import GroupDetail from "../views/dashboard/app/group-detail";
import FriendList from "../views/dashboard/app/friend-list";
import ProfileImages from "../views/dashboard/app/profile-images";
import ProfileVideos from "../views/dashboard/app/profile-videos";
import ProfileEvents from "../views/dashboard/app/profile-events";
import EventDetail from "../views/dashboard/app/event-detail";
import Calendar from "../views/dashboard/app/calendar";
import Birthday from "../views/dashboard/app/birthday";
import Weather from "../views/dashboard/app/weather";
import Music from "../views/dashboard/app/music";
import CatergoryGrid from "../views/dashboard/store/store-category-grid";
import CatergoryList from "../views/dashboard/store/store-category-list";
import StoreDetail from "../views/dashboard/store/store-detail";
import StoreCheckout from "../views/dashboard/store/store-checkout";

//market and profile pages
import Market1 from "../views/dashboard/market-place/market1";
import Market2 from "../views/dashboard/market-place/market2";
import Profile1 from "../views/dashboard/profiles/profile1";
import Profile2 from "../views/dashboard/profiles/profile2";
import Profile3 from "../views/dashboard/profiles/profile3";
import AllPost from "../views/dashboard/AllPost";
import MyPost from "../views/dashboard/MyPost";
import Event from "../views/dashboard/Event";
import Saved from "../views/dashboard/Saved";
import DeviceDescription from "../views/Lost&Found/DeviceDescription";
import LostDeviceList1 from "../views/Lost&Found/LostDeviceList1";
import CreateQrcLost from "../views/Lost&Found/CreateQrcLost";
import LostFoundList from "../views/Lost&Found/LostFoundList";
import Connections from "../views/dashboard/app/Connections";
import Critical from "../views/dashboard/app/Critical/Critical";
import ConnectionPosts from "../views/dashboard/ConnectionPosts";
import Jobs from "../views/dashboard/Jobs/Jobs";
import ForSale from "../views/dashboard/ForSale/Forsale";
import Entertainment from "../views/dashboard/entertainment/Entertainment";
import Travel from "../views/dashboard/Travel/Travel";
import Meet from "../views/dashboard/Meet/Meet";
import CriticalTabs from "../views/dashboard/app/Critical/CriticalTabs";
import CriticalTabs1 from "../views/dashboard/app/Critical/CriticalTabs1";
import CriticalTabs2 from "../views/dashboard/app/Critical/CriticalTabs2";
import Deal from "../views/dashboard/Deal/Deal";
import Housing from "../views/dashboard/Housing/Housing";
import Services from "../views/dashboard/Services/Services";
import LostItemPage from "../views/Lost&Found/LostItemPage";
import PaymentSuccess from "../components/Payment/PaymentSuccess";

export const Layout1Router = [
  {
    path: "groups",
    element: <Groups />,
  },
  {
    path: "group-detail/:groupid",
    element: <GroupDetail />,
  },
  {
    path: "dashboards/app/friend-list",
    element: <FriendList />,
  },
  {
    path: "dashboards/app/profile-images",
    element: <ProfileImages />,
  },
  {
    path: "dashboards/app/profile-videos",
    element: <ProfileVideos />,
  },
  {
    path: "dashboards/app/profile-events",
    element: <ProfileEvents />,
  },
  {
    path: "dashboards/app/event-detail",
    element: <EventDetail />,
  },
  {
    path: "dashboards/app/calendar",
    element: <Calendar />,
  },
  {
    path: "dashboards/app/birthday",
    element: <Birthday />,
  },
  {
    path: "dashboards/app/weather",
    element: <Weather />,
  },
  {
    path: "dashboards/app/music",
    element: <Music />,
  },
  {
    path: "store",
    element: <CatergoryGrid />,
  },
  {
    path: "advertisements",
    element: <CatergoryList />,
  },
  // {
  //   path: "dashboards/store/store-detail",
  //   element: <StoreDetail />,
  // },
  // {
  //   path: "dashboards/store/store-checkout",
  //   element: <StoreCheckout />,
  // },
  {
    path: "dashboards/market-place/market1",
    element: <Market1 />,
  },
  {
    path: "dashboards/market-place/market2",
    element: <Market2 />,
  },
  {
    path: ":countryCode/:userid",
    element: <Profile1 />,
  },
  // {
  //   path: "myprofile",
  //   element: <Profile1 />,
  // },
  {
    path: "dashboards/profiles/profile2",
    element: <Profile2 />,
  },
  {
    path: "dashboards/profiles/profile3",
    element: <Profile3 />,
  },
  {
    path: "mypost",
    element: <MyPost />,
  },
  {
    path: "allpost",
    element: <AllPost />,
  },
  {
    path: "connectionposts",
    element: <ConnectionPosts />,
  },
  {
    path: "events",
    element: <Event />,
  },
  // {
  //   path: "events1",
  //   element: <GroupDetail />,
  // },
  {
    path: "saved",
    element: <Saved />,
  },
  {
    path: "device-list",
    element: <LostDeviceList1 />,
  },
  {
    path: "create-qrc",
    element: <CreateQrcLost />,
  },
  { 
    path: "device-list/my-lost-device-list",
    element: <LostFoundList  />,
    
  },
  {
    path: "device-list/all-lost-device-list/:key",
    element: <LostFoundList  />,
    
  },
  {

    path: "connections",
    element: <Connections />,
  },
  // {

  //   path: "critical0",
  //   element: <CriticalTabs />,
  // },
  // {

  //   path: "critical1",
  //   element: <CriticalTabs1 />,
  // },
  // {

  //   path: "lostitem",
  //   element: <LostItemPage />,
  // },
  {

    path: "critical",
    element: <CriticalTabs2 />,
  },
  {
    path: "jobs",
    element: <Jobs />,
  },
  {
    path: "forsale",
    element: <ForSale />,
  },
  {
    path: "entertainment",
    element: <Entertainment />,
  },
  {
    path: "travel",
    element: <Travel />,
  },
  {
    path: "meet",
    element: <Meet />,
  },
  {
    path: "deals",
    element: <Deal />,
  },
  {
    path: "housing",
    element: <Housing />,
  },
  {
    path: "services",
    element: <Services />,
  },
 


];

